<template>
  <div>
    <div id="drop-area" :class="dropActive ? 'drop-active' : ''">
        <input class="video" type="file" ref="video" @change="fileUpload" id="fileUpload" multiple  accept=".mp4" />
        <p >将文件拖到此处，或 </p>
        <p  class="onUpload" @click="videoUpload()"> 点击上传</p>
        <p v-if="isid">{{ fileList.length != 0 ? fileList[fileList.length-1].file.name : ''  }}</p>
        
    </div>
    <div v-if="!isid">
      <!-- <i style="color: rgb(155, 227, 10);" class="el-icon-check"></i> <i class="el-icon-loading"></i> -->
      <p  class="vitem" v-for="(item,index) in watchfileList" :key="index"><span>{{ index + 1 }}</span> <span>{{ item.file.name }}</span> <span >{{ item.same }}</span> <i @click="removeList(index)" class="el-icon-close"></i> 
       
        <i v-if="item.isupload == 0" class="el-icon-loading"></i>
        <span v-else-if="item.isupload == 1">失败</span>
        <i v-else-if="item.isupload == 2" style="color: rgb(155, 227, 10);" class="el-icon-check"></i>
        <span v-else></span>
        
      </p>
    </div>
  </div>
    
  </template> 
  <script>
  export default {
  name:'DropFile',
  props: ['isid'],
  data(){
    return {
      dropActive:false,
      fileList: [],
      watchfileList: []
    }
  },
  watch: {
    fileList: {
      handler(n,o){
        // console.log(n)
        this.watchfileList = this.updateSameProperty(n)
        console.log(this.watchfileList)
        
      },
      deep: true
    }
  },
  methods:{
    updateSameProperty(list) {
      let newArr = list[0] ?  [list[0]] : []
            for (let i = 1; i < list.length; i++) {
                let repeat = false;
                for (let j = 0; j < newArr.length; j++) {
                  console.log(list[i].name)
                    if (list[i].file.name === newArr[j].file.name) {
                        repeat = true;
                        break; 
                    }else{
                        
                    }
                }
                 if (!repeat) {
                  list[i].same = ''
                   newArr.push(list[i]);
                }else{  
                    list[i].same = '重复'
                    newArr.push(list[i]);
                }
            }
            return newArr;
      },
    videoUpload(){
      this.$refs.video.click()
    },
    removeList(i){
      this.fileList.splice(i,1)
    },
    fileUpload: function (e) { 
      console.log(e,'23')
    //e为事件对象    
    console.log(e.target.files)
    if(e.target.files.length > 10 || e.target.files.length + this.fileList.length > 10){
      // this.$message({
      //           message:`你选中了${e.target.files.length}个文件，当前最多同时可选${ }个,`,
      //           type:'warning',

      //     })
      
      let num = 10 - this.fileList.length > 0 ? 10 - this.fileList.length : 0
      this.$confirm(`你选中了${e.target.files.length}个文件，当前最多同时可选${ num }个,确定后将只上传前${ num }个`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let i = 0
          for (const file of e.target.files) {
            if(i < num){
              this.fileList.push({file: file, isupload: 6,})
              i++
            }
        }
          
        }).catch(() => {
               
        });
      return    
    }
    for (const file of e.target.files) {

          this.fileList.push({file: file, isupload: 6,})
          console
    }
    },
    dropEvent(e) {
      this.dropActive = false
      e.stopPropagation()
      e.preventDefault()
      this.uploadFile(e.dataTransfer.files)
    },
    uploadFile (file) { // 渲染上传文件
      let  obj = {target:{files: file}} 
      this.fileUpload(obj)
      // if (file && file.length) {
      //   if(file[0].type == "video/mp4"){
            
      //       this.fileList.push(file[0])
      //   }else{
      //       this.$message({
      //           message:'请选择mp4格式的文件',
      //           type:'warning',
      //       })
      //   }
       
      //   // console.log(this.fileList)
      //   //自行发挥，存本地或上传服务器
      // }
    },
  },
  mounted () {
    let dropArea = document.getElementById('drop-area')
    dropArea.addEventListener('drop', this.dropEvent, false)
    dropArea.addEventListener('dragleave', (e) => {
      e.stopPropagation()
      e.preventDefault()
      this.dropActive = false
    })
    dropArea.addEventListener('dragenter', (e) => {
      e.stopPropagation()
      e.preventDefault()
      this.dropActive = true
    })
    dropArea.addEventListener('dragover', (e) => {
      e.stopPropagation()
      e.preventDefault()
      this.dropActive = true
    })
  }
  }
  </script>
  <style scoped lang="scss">
  #drop-area {
    width: 100%;
    height: 50px;
    color: rgba(0, 0, 0, 0.45);
    text-align: center;
    display: flex;
    justify-content: center;
    transform: translateX(-60px);
    // background-color: #fafafa;
    // border: 1px dashed #d9d9d9;
   
  }
  .drop-active{
//   background-color: rgba(231,234,246,0.8);
  }
  #fileUpload{
    display: none;
  }
  .onUpload{
    margin-left: 20px;
    color: rgb(69, 193, 241);
    cursor: pointer;
  }
  .vitem{
   
    display: flex;
    width: 60%;
    align-items: center;
    & :nth-child(1){
      margin-right: 30px;
    }
    & :nth-child(2){
      flex: 1;
     
      margin-right: 10px;
    }
    & :nth-child(3){
      color: red;
      margin-right: 10px;
    }
    
  }
  </style>